/** Empties a native input like a user would, so React fires the element's regular `onChange` with an empty value. */
export const clearNativeInputValue = (
  element: HTMLInputElement | HTMLTextAreaElement,
) => {
  const prototype =
    element instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : HTMLInputElement.prototype
  // The prototype setter bypasses React's value tracking, otherwise React would swallow the event.
  const setValue = Object.getOwnPropertyDescriptor(prototype, 'value')!.set!
  setValue.call(element, '')
  element.dispatchEvent(new Event('input', { bubbles: true }))
  element.focus()
}
